import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerifySliceForm = createAsyncThunk(
  'stop/getVerifySliceForm',
  async (params) => {
    const { url, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(url, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verifySliceForm = createSlice({
  name: 'stop/verificationMonth',
  initialState: null,
  reducers: {
    resetVerifyForm: () => null,
  },
  extraReducers: {
    [getVerifySliceForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetVerifyForm } = verifySliceForm.actions;

export default verifySliceForm.reducer;
